import { render, staticRenderFns } from "./batchEditPrices.vue?vue&type=template&id=1ef1fde8&"
import script from "./batchEditPrices.vue?vue&type=script&lang=js&"
export * from "./batchEditPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports